const coef = 100

// convert cents to dollars
export const entriesToMoney = (entires: number): number => {
  return entires / coef
}

// convert dollars to cents
export const moneyToEntries = (money: number): number => {
  return money * coef
}

// Total cancellations on a shift. The Kiosk API reports redeem cancellations
// (`cancelRedeems`) separately from purchase cancellations (`cancels`); the
// "Adjustment" figures shown in the app cover both.
export const totalCancels = (shift: { cancels: number; cancelRedeems?: number }): number => {
  return (shift.cancels ?? 0) + (shift.cancelRedeems ?? 0)
}
